import { TooltippedIconButton } from '@mews-commander/ui';
import { Button, IconName } from '@optimus-web/core';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { ConnectedEditDialogForm } from '@mews-commander/legacy-form';
import { KeyCutter } from '@mews-commander/data-access';
import { KeyCutterForm } from './KeyCutterForm';
import { FormValues } from './types';

interface Props {
    activeDialog: boolean;
    defaultKeyCutterId: string | null;
    initKeyCount?: number;
    isCheckedIn: boolean;
    keyCutters: KeyCutter[] | undefined;
    onClick: () => void;
    onCloseDialog: () => void;
    onSubmit: (values: FormValues) => Promise<void>;
    textKey?: Mews.TextKey;
}

const keyCutterFormName = 'key-cutter-form';

export const KeyCutterButtonView = ({
    activeDialog,
    defaultKeyCutterId,
    textKey,
    initKeyCount,
    isCheckedIn,
    keyCutters,
    onClick,
    onCloseDialog,
    onSubmit,
}: Props) => {
    const buttonProps = {
        icon: IconName.Key,
        onClick,
        variant: 'tertiary' as const,
        size: 'small' as const,
        'data-test-id': DataTestId.KeyCutterButton,
        type: 'button' as const,
    };

    const initialValues = { keyCount: initKeyCount, keyCutter: defaultKeyCutterId };

    const form =
        keyCutters != null ? (
            <KeyCutterForm
                form={keyCutterFormName}
                initialValues={initialValues}
                isCheckedIn={isCheckedIn}
                showKeyCutterCount={!!initKeyCount}
                keyCutters={keyCutters}
                onSubmit={onSubmit}
            />
        ) : null;

    return (
        <>
            {textKey != null ? (
                <Button {...buttonProps} type="submit">
                    <LocalizedText textKey={textKey} />
                </Button>
            ) : (
                <TooltippedIconButton tooltip={<LocalizedText textKey={TextKey.CreateKeys} />} {...buttonProps} />
            )}
            <ConnectedEditDialogForm
                formName={keyCutterFormName}
                active={activeDialog}
                primaryButtonTextKey={TextKey.CreateKey}
                closeDialog={onCloseDialog}
                title={<LocalizedText textKey={TextKey.CreateKeys} />}
            >
                {form}
            </ConnectedEditDialogForm>
        </>
    );
};
